var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "min-height": "calc(100vh - 11em) !important" } },
    [
      _vm.getUpdateSuccessMsg
        ? _c(
            "div",
            {
              staticClass: "alert alert-success text-left",
              attrs: { role: "alert" }
            },
            [_c("span", [_vm._v("Update to the integration has been applied")])]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.getAddSuccessMsg
        ? _c(
            "div",
            {
              staticClass: "alert alert-success text-left",
              attrs: { role: "alert" }
            },
            [_c("span", [_vm._v("The carrier has been added successfully")])]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row no-gutters mb-3 head-container" }, [
        _c("div", { staticClass: "col-12 col-md-6 display-1" }, [
          _vm._v(_vm._s(_vm.carrierName))
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-12 col-md-6 mt-sm-2 mt-md-0 text-sm-left text-md-right"
          },
          [
            _vm.tabIndex == 1
              ? _c(
                  "router-link",
                  {
                    staticClass: "btn btn-outline-secondary",
                    attrs: {
                      to: { name: "carrier-manager" },
                      tag: "button",
                      tabindex: "1"
                    }
                  },
                  [_vm._v("Cancel")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.tabIndex == 1
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-success",
                    attrs: { type: "button", tabindex: "1" },
                    on: {
                      click: function($event) {
                        return _vm.saveCarrier(_vm.tabIndex)
                      }
                    }
                  },
                  [_vm._v("Save Changes")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.tabIndex == 0
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-success",
                    attrs: { type: "button", disabled: _vm.disabled },
                    on: {
                      click: function($event) {
                        return _vm.openAdd()
                      }
                    }
                  },
                  [_vm._v("+Add New Integration")]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "b-tabs",
            {
              attrs: { "content-class": "mt-3" },
              model: {
                value: _vm.tabIndex,
                callback: function($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex"
              }
            },
            [
              _c(
                "b-tab",
                {
                  attrs: { title: "Carrier Integration", lazy: "", active: "" }
                },
                [_c("state-integration", { ref: "stateIntegration" })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Agency Integrations", lazy: "" } },
                [_c("agency-integration", { ref: "agencyIntegration" })],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c2292da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c2292da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/carriers/EditCarrier.vue
// module id = null
// module chunks = 